module.exports = __webpack_public_path__ + "static/media/Pattern.8b69903e.jpg";